import { gql } from "@apollo/client";  
import { BUSINESS_FIELDS_FRAGMENT } from "./business";

export const GET_RATINGS = gql`
  query GetRatings($bookingTypeId: Int!) {
    getRatings(bookingTypeId: $bookingTypeId) {
      id
      bookingTypeId
      bookingId
      review
      rating
      desc
    }
  }
`;

export const GET_INVITEE_QUESTIONS = gql`
  query GetInviteeQuestions($bookingTypeId: Int, $staffId: Int) {
    getInviteeQuestions(bookingTypeId: $bookingTypeId, staffId: $staffId) {
      id
      title
      type
      required
      bookingTypeId
    }
  }
`;
export const GET_INVITEE_ANSWERS = gql`
  query getInviteeAnswers($bookingTypeId: Int!) {
    getInviteeAnswers(bookingTypeId: $bookingTypeId) {
      id
      title
      questionId
    }
  }
`;
export const GET_BOOKING_ANSWERS = gql`
  query GetBookingAnswers($staffId: Int, $email: String) {
    getBookingAnswers(staffId: $staffId, email: $email) {
      id
      answer
      questionId
      bookingId
    }
  }
`;
export const GET_INTEGRATION = gql`
  query getIntegration($integration: String!) {
    getIntegration(integration: $integration) {
      id
      name
      logo
      description
      tags
    }
  }
`;
export const GET_INTEGRATIONS = gql`
  query getIntegrations {
    getIntegrations {
      id
      name
      logo
      description
      tags
    }
  }
`;
export const GET_USER_INTEGRATIONS = gql`
  query getUserIntegrations($staffId: Int!) {
    getUserIntegrations(staffId: $staffId) {
      integrationId
    }
  }
`;
export const GET_ALL_TAGS = gql`
  query {
    getAllTags
  }
`;

export const GET_TOKEN = gql`
  query GetToken($userId: Int, $staffId: Int, $subscriptionId: Int, $businessId: Int) {
    getToken(
      userId: $userId
      staffId: $staffId
      subscriptionId: $subscriptionId
      businessId: $businessId
    ) {
      token
    }
  }
`;


export const GET_BUSINESS_BY_CATEGORYID = gql`
query BusinessByCategory($categoryId: Int!, $cityId: Int, $countryId: Int) {
  businessByCategory(categoryId: $categoryId, cityId: $cityId, countryId: $countryId) {
    ${BUSINESS_FIELDS_FRAGMENT}
  }
}
`


export const SEARCH = gql`
query SearchBusinesses($query: String!) {
  search(query: $query) {
    ${BUSINESS_FIELDS_FRAGMENT}
  }
}
`

export const GET_ACTIVE_BUSINESS_CATEGORIES = gql`
query GetBookingTypesByActiveCities($countryId: Int!) {
  getBookingTypesByActiveCities(countryId: $countryId) {
    city
    cityId
    categories {
      id
      name
    }
  }
}
`

export const CHECK_LINK = gql`
 query CheckLink($link: String!, $bookingTypeId: Int) {
  checkBookingLink(link: $link, bookingTypeId: $bookingTypeId)
}
  `

export const GET_PAYMENTS = gql`
  query Payments($businessUrl: String!) {
  payments(businessUrl: $businessUrl) {
  id
  identifier  
  businessId
  paymentMethod {
    id
    type
    isActive
  }
  }
}
`
export const ADD_PAYMENT = gql`
mutation AddPayment($businessId: ID!, $identifier: String!, $paymentMethodId: ID!) {
  addPayment(businessId: $businessId, identifier: $identifier, paymentMethodId: $paymentMethodId) {
    id
    identifier
  }
}
`

export const UPDATE_PAYMENT = gql`
mutation UpdatePayment($id: ID!, $identifier: String!) {
  updatePayment( id: $id, identifier: $identifier) {
    id
    identifier
  }
}
`

export const DELETE_PAYMENT = gql`
mutation DeletePayment($id: ID!) {
  deletePayment(id: $id) {
    message
  }
}
`

export const GET_PAYMENT_METHODS = gql`
 query PaymentMethods{ 
  paymentMethods { 
  id
  type  
  isActive
  }
}
`;

export const UPDATE_PAYMENT_METHOD = gql`
  mutation UpdatePaymentMethod($id: ID!, $isActive: Boolean!) {
    updatePaymentMethod(id: $id, isActive: $isActive) {
      id
      isActive
    }
  }
`;

export const DELETE_PAYMENT_METHOD = gql`
  mutation DeletePaymentMethod($id: ID!) {
    deletePaymentMethod(id: $id) {
      id
    }
  }
`;

export const GET_PLANS = gql`
  query Plans($planEnv: String!) { 
    plans(planEnv: $planEnv) { 
      id
      name
      features
      priceMonthly
      priceYearly
      paymentMethods {
        isActive
        planId
        paymentName
        monthlyPlanId
        yearlyPlanId
        env
      }
    }
  }
`;

export const CHECK_SUBSCRIPTION = gql`
  query Query($subscriptionId: String!) {
  checkSubscription(subscriptionID: $subscriptionId)
}
`; 

export const GET_GOOGLE_CALENDAR_EVENTS = gql`
  query GetGoogleCalendarEvents($staffId: Int!, $currentMonth: String!) {
    getGoogleCalendarEvents(staffId: $staffId, currentMonth: $currentMonth) {
      success
      events {
        id
        bookingTypeId
        timezone
        bookingId
        time
        createdAt
        status
        inviteeName
        inviteeEmail
        bookingTypeName
        staffName
        staffId
        duration
        isAllDay
        source
      }
    }
  }
`;
 
export const CHECK_GOOGLE_CALENDAR_INTEGRATION = gql`
  query Query($staffId: Int!) {
  checkGoogleCalendarIntegration(staffId: $staffId)
}
`;


export const GET_CALENDAR_CATEGORIES = gql`
  query GetCalendarCategories {
    getCalendarCategories {
      id
      name
      calendars {
        id
        name
        type
      }
    }
  }
`;

export const GET_CALENDARS_BY_CATEGORY = gql`
  query GetCalendarsByCategory($categoryId: ID!) {
    getCalendarsByCategory(categoryId: $categoryId) {
      id
      name
      type
    }
  }
`;

export const ADD_CUSTOM_CALENDAR = gql`
  mutation AddCustomCalendar($input: AddCustomCalendarInput!) {
    addCustomCalendar(input: $input) {
      id
      name
    }
  }
`;

export const REMOVE_CUSTOM_CALENDAR = gql`
  mutation RemoveCustomCalendar($id: ID!) {
    removeCustomCalendar(id: $id) {
      message
    }
  }
`;
